import { ReactElement } from 'react';
import { CompanyDetailsInterface } from '../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';
import useOrderMethodsStatus from './useOrderMethodsStatus';
import useOpeningStatus from './useOpeningStatus';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import classnames from 'classnames';

interface Props {
  data?: CompanyDetailsInterface;
  className?: string;
}

export default function useOrderingDisabledStatus(props: Props = {}) {
  const { t } = useTranslation(null, { keyPrefix: 'Hooks:Availability:UseOrderingDisabledStatus' });

  const { data, className } = props;

  const { company: companyData } = useSelector((state: StoreInterface) => state.initialData);
  const { cached_order } = useSelector((state: StoreInterface) => state.order);
  const company = data ?? companyData;

  const openingStatus = useOpeningStatus({ data: company });
  const { takeoutEnabled, isOrderMethodCurrentlyOpen, orderingDisabled } = useOrderMethodsStatus();

  function render(): ReactElement {
    if (!takeoutEnabled) {
      return (
        <div className={classnames(closedCompanyContainer, className)}>
          <h4 className={closedTextStyle}>{t('error_messages.orders_disabled')}</h4>
        </div>
      );
    }

    if (!orderingDisabled(cached_order?.method)) {
      return null;
    }

    if (!isOrderMethodCurrentlyOpen(cached_order?.method)) {
      return (
        <div className={classnames(closedCompanyContainer, className)}>
          <h4 className={closedTextStyle}>{openingStatus.details_text}</h4>
        </div>
      );
    }
  }

  return {
    render: render(),
  };
}

const closedCompanyContainer =
  'lg:sticky fixed bottom-0 w-full flex flex-row items-center justify-center px-lg py-md !bg-gray border-t';

const closedTextStyle = 'text-muted-foreground text-center';
